// import 'babel-polyfill';
import React from "react";
import {createRoot} from 'react-dom/client';
import "./app.scss";
// 引入路由
import { HashRouter } from "react-router-dom";
import AppRouter from "./router/index";
import config from "./config";

// import share from 'chelun-libs/common/js/share';
import { share } from "cl-util";

// 百度统计
//config.baiduCountID && utils.baidu();

if (window.location.hash.indexOf("gas") != -1) {
  //加油站分享
  share(config.gasShareInfo);
} else if (window.location.hash.indexOf("upkeep") != -1) {
  //小保养分享
  share(config.upkeepShareInfo);
} else {
  // 调用分享
  share(config.shareInfo);
}

window["CHELUN_SHOW_OPTION_MENU"] = config.CHELUN_SHOW_OPTION_MENU;
window["CHELUN_SHOW_MENU_ITEMS"] = config.CHELUN_SHOW_MENU_ITEMS;
const container = document.getElementById(config.appRootEle);
const root = createRoot(container);
root.render( <HashRouter> <AppRouter /></HashRouter> );